import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-723f79b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, "›", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "current" }, "策略详情", -1))
const _hoisted_4 = { class: "page-scroll-container" }
const _hoisted_5 = { class: "content-layout" }
const _hoisted_6 = { class: "top-row" }
const _hoisted_7 = { class: "left-col" }
const _hoisted_8 = { class: "right-col" }
const _hoisted_9 = { class: "bottom-row" }

import StarXpGate from '@/components/star/StarXpGate.vue'
import { isXpLowVersion } from '@/utils/xpEnv'
import StarTabBar from '@/components/star/StarTabBar.vue'
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStarTheme, useStarRouter } from '@/utils/useStarTheme'
import type { TemplateLockState } from '@/utils/useStarTemplateLock'
import { fetchStrategyDetail } from '@/api/starresultApi'
import store from '@/store/index'
import StrategyHeader from '../components/StrategyHeader.vue'
import StrategyDetails from '../components/StrategyDetails.vue'
import YieldTrend from '../components/YieldTrend.vue'
import PositionTransactions from '../components/PositionTransactions.vue'
import BacktestStatusOverlay from '../components/BacktestStatusOverlay.vue'
import ActionFooter from '../components/ActionFooter.vue'
import StarTipDialog from '@/components/star/StarTipDialog.vue'
import StarActivationDialog from '@/components/star/StarActivationDialog.vue'
import { useStarTip } from '@/utils/useStarTip'
import { useStarActivation, queryStarActivationStatus } from '@/utils/useStarActivation'


export default /*#__PURE__*/_defineComponent({
  __name: 'result',
  setup(__props) {

const route = useRoute()
const { colors, isDark } = useStarTheme()
const { starPush } = useStarRouter()
const activeTopTab = ref('square')

const cssVars = computed(() => ({
  '--bg-color': colors.value.bg,
  '--card-bg': colors.value.bgCard,
  '--card-bg-sub': colors.value.bgCardSub,
  '--text-primary': colors.value.textPrimary,
  '--text-secondary': colors.value.textSecondary,
  '--text-muted': colors.value.textMuted,
  '--border-color': colors.value.border,
  '--accent-color': colors.value.accent,
  '--divider-color': colors.value.divider,
  '--rise-color': colors.value.rise,
  '--fall-color': colors.value.fall,
}))

const goSquare = () => starPush('/star/square')

const strategyDetails = ref<any>({})
const holdings = ref<any[]>([])
const tradeID = ref('')
const backtestStatus = ref(2)
const backtestToast = ref('')
const positionTransactionsRef = ref<any>(null)
const yieldTrendRef = ref<any>(null)
const actionFooterRef = ref<any>(null)
const detailLoaded = ref(false)
const {
  tipDialog,
  unlock,
  showUnlockDialog,
  handleUnlockClose,
  handleUnlockBannerClick,
  handleUnlockShareClose,
  handleUnlockPromoClose,
  handleUnlockPurchaseClick,
} = useStarTip()
const {
  showActivationDialog,
  showActivationQr,
  openActivationQr,
  refreshActivation,
  hideActivation,
} = useStarActivation()

const starUserName = computed(
  () => store.state.userInfo?.username || store.state.userInfo?.userName || ''
)

const templateLockState = computed<TemplateLockState>(() => {
  const token = route.query.token as string
  if (!token) return 'unlocked'
  if (!detailLoaded.value) return 'pending'
  const hasPermission = route.query.hasPermission as string
  if (hasPermission === '0') return 'locked'
  if (hasPermission === '1') return 'unlocked'
  if (strategyDetails.value?.comTemplateResult?.hasAuth === false) return 'locked'
  return 'unlocked'
})

const handleUnlock = async () => {
  const result = await queryStarActivationStatus(route, starUserName.value)
  if (result.success && result.hasUnactivatedOrder) {
    showActivationQr.value = false
    showActivationDialog.value = true
    return
  }
  hideActivation()
  await showUnlockDialog()
}

const handleTemplateUnlock = () => {
  void handleUnlock()
}

const loadDetail = async () => {
  const taskID = (route.query.taskID as string) || ''
  const token = route.query.token as string
  const username = store.state.userInfo?.username || (route.query.username as string)

  if (!taskID) {
    detailLoaded.value = true
    return
  }

  try {
    const res: any = await fetchStrategyDetail({
      data: { taskID },
      headers: { token, username },
    })
    if (res?.data) {
      backtestStatus.value = res.data.status as number
      backtestToast.value = res.data.toast || ''
      if (res.data.status === 2) {
        strategyDetails.value = res.data
        tradeID.value = res.data.tradeId || ''
        holdings.value =
          res.data.comTemplateResult?.holdings ||
          res.data.comResult?.holdings ||
          []
      }
    }
  } catch (e) {
    console.error('Failed to fetch strategy detail:', e)
  } finally {
    detailLoaded.value = true
  }
}

const refreshDetail = () => {
  loadDetail()
  yieldTrendRef.value?.reload()
}

const handleRefreshAll = async () => {
  await loadDetail()
  positionTransactionsRef.value?.reload()
  yieldTrendRef.value?.reload()
}

const strategyTags = computed(() => {
  const tags: string[] = []
  const d = strategyDetails.value
  if (!d) return tags
  if (d.quantType === 3) tags.push('组合量化')
  if (d.isSubscribed) tags.push('已订阅')
  if (d.tagList?.length) {
    d.tagList.forEach((t: any) => {
      if (t.tagName) tags.push(t.tagName)
    })
  }
  return tags
})

const strategyRemark = computed(
  () => strategyDetails.value?.comTemplateResult?.remark || '',
)

const strategyColor = computed(() => {
  const cumRet = strategyDetails.value?.summary?.cumRet
  if (cumRet == null) return '#ff5c5c'
  if (cumRet > 0) return '#fe4043'
  if (cumRet < 0) return '#39e365'
  return '#888888'
})

onMounted(() => {
  if (isXpLowVersion(route.query as Record<string, unknown>)) return
  if (route.query.isocbt === '1') {
    backtestStatus.value = 1
  } else {
    loadDetail()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StarXpGate, { na: "starSquareResult" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "star-result-page star-page",
        style: _normalizeStyle(_unref(cssVars))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(StarTabBar, {
            modelValue: activeTopTab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTopTab).value = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", {
            class: "breadcrumb",
            style: _normalizeStyle({ background: _unref(isDark) ? '#181818' : '#ffffff' })
          }, [
            _createElementVNode("span", {
              class: "nav-item",
              onClick: goSquare
            }, "模版策略"),
            _hoisted_2,
            _hoisted_3
          ], 4)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_unref(route).query.isDetails)
                  ? (_openBlock(), _createBlock(StrategyHeader, {
                      key: 0,
                      strategyDetails: strategyDetails.value,
                      strategyName: strategyDetails.value.title || '--',
                      remark: _unref(strategyRemark),
                      tags: _unref(strategyTags),
                      isDark: _unref(isDark)
                    }, null, 8, ["strategyDetails", "strategyName", "remark", "tags", "isDark"]))
                  : _createCommentVNode("", true),
                _createVNode(StrategyDetails, {
                  strategyDetails: strategyDetails.value,
                  isDark: _unref(isDark),
                  isFactor: true,
                  "use-com-template-result": true,
                  "logic-lock-state": _unref(templateLockState),
                  onUnlock: handleTemplateUnlock
                }, null, 8, ["strategyDetails", "isDark", "logic-lock-state"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(YieldTrend, {
                  ref_key: "yieldTrendRef",
                  ref: yieldTrendRef,
                  isDark: _unref(isDark),
                  isFactor: true,
                  isSubscribed: strategyDetails.value.isSubscribed,
                  strategyColor: _unref(strategyColor),
                  noBuySell: !!strategyDetails.value.noBuySell,
                  pageType: strategyDetails.value.pageType
                }, null, 8, ["isDark", "isSubscribed", "strategyColor", "noBuySell", "pageType"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(PositionTransactions, {
                ref_key: "positionTransactionsRef",
                ref: positionTransactionsRef,
                isDark: _unref(isDark),
                holdings: holdings.value,
                tradeID: tradeID.value,
                "content-lock-state": _unref(templateLockState),
                onUnlock: handleTemplateUnlock
              }, null, 8, ["isDark", "holdings", "tradeID", "content-lock-state"])
            ])
          ])
        ]),
        _createVNode(ActionFooter, {
          ref_key: "actionFooterRef",
          ref: actionFooterRef,
          isDark: _unref(isDark),
          strategyDetails: strategyDetails.value,
          "square-template": "",
          "template-lock-state": _unref(templateLockState),
          onUnlock: handleUnlock,
          onRefresh: handleRefreshAll
        }, null, 8, ["isDark", "strategyDetails", "template-lock-state"]),
        _createVNode(StarTipDialog, {
          tipDialog: _unref(tipDialog),
          unlock: _unref(unlock),
          onUnlockClose: _unref(handleUnlockClose),
          onUnlockBannerClick: _unref(handleUnlockBannerClick),
          onUnlockShareClose: _unref(handleUnlockShareClose),
          onUnlockPromoClose: _unref(handleUnlockPromoClose),
          onUnlockPurchaseClick: _unref(handleUnlockPurchaseClick)
        }, null, 8, ["tipDialog", "unlock", "onUnlockClose", "onUnlockBannerClick", "onUnlockShareClose", "onUnlockPromoClose", "onUnlockPurchaseClick"]),
        _createVNode(StarActivationDialog, {
          visible: _unref(showActivationDialog),
          "show-qr": _unref(showActivationQr),
          onActivate: _unref(openActivationQr),
          onRefresh: _cache[1] || (_cache[1] = () => _unref(refreshActivation)(_unref(route), _unref(starUserName))),
          onClose: _unref(hideActivation)
        }, null, 8, ["visible", "show-qr", "onActivate", "onClose"]),
        _createVNode(BacktestStatusOverlay, {
          status: backtestStatus.value,
          "toast-string": backtestToast.value,
          onRefresh: refreshDetail
        }, null, 8, ["status", "toast-string"])
      ], 4)
    ]),
    _: 1
  }))
}
}

})